export default __webpack_public_path__ + "assets/img/4980bb0c50dca54c45a53461c92f0560.svg";